import React from 'react'
import styled from 'styled-components'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import ExpectationBulletPoint from 'src/Result/ExpectationDetail/ExpectationBulletPoint'
import { localize } from 'src/lib/localize'

const Container = styled.div`
  flex: 1;
`

const title1 = localize('LABEL')('Very slow or unwatchable streaming')
const title2 = localize('LABEL')('Slow web browsing')
const title3 = localize('LABEL')('Unstable video calls')
const title4 = localize('LABEL')('Unstable connected gaming')

const UnstableExpectationDetails = () => {
  return (
    <Container>
      <ExpectationBulletPoint
        resultState={SpeedResultState.UNSTABLE}
        title={title1}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.UNSTABLE}
        title={title2}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.UNSTABLE}
        title={title3}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.UNSTABLE}
        title={title4}
      />
    </Container>
  )
}

export default UnstableExpectationDetails
